module.exports = {

    apiPrefix: '/api',
    build: 1.03,  
    

};